export const IS_MOBILE =
	!!/mobile|iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile|ipad|android|android 3.0|xoom|sch-i800|playbook|tablet|kindle/i.test(
		navigator.userAgent,
	);

// Specific constant for iOS devices
// http://racase.com.np/javascript-how-to-detect-if-device-is-ios/
// Reason: We're keeping the MSStream check until further notice.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as { MSStream?: any }).MSStream;

// To find url in string
export const HTTP_FILE_PATTERN = /(\b((https?|ftp|file):\/\/)[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|]*)/i;

export const WWW_PATTERN = /(^|[^/])(www.[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|]+(\b|$))/i;

export const MAILTO_PATTERN = /\bmailto:(.*)(\?.*)?\b/;

export const PUBLIC_SUB_URL_PATH = 'v';

// To keep all standard shadows the same
export const STANDARD_BOX_SHADOW = '0 1px 4px rgb(0 0 0 / 5%)';

export enum SPACE_SIZE {
	XS = 'var(--vc--space--xs)',
	S = 'var(--vc--space--s)',
	M = 'var(--vc--space--m)',
	L = 'var(--vc--space--l)',
	XL = 'var(--vc--space--xl)',
}

export enum FONT_VARIANT {
	LARGE_TITLE = 'var(--vc--font--large-title)',
	TITLE = 'var(--vc--font--title)',
	SMALL_TITLE = 'var(--vc--font--small-title)',
	SMALL_TITLE_BOLD = 'var(--vc--font--small-title--bold)',
	BODY = 'var(--vc--font--body)',
	LARGE_BODY = 'var(--vc--font--large-body)',
	SMALL_BODY = 'var(--vc--font--small-body)',
	BODY_BOLD = 'var(--vc--font--body--bold)',
}

// Arbitrary value to not overwhelm the user with visual feedback (a lot of animations is happening)
export const SHEET_CLOSE_INTO_NOTIFICATION_WAIT = 350;

export const ASSET_IMAGE_PATH = '/assets/images';

// The PW translation set, the one and only!
export const TRANSLATION_SET = 'PatientWeb' as const;
